<template>
  <button
    class="control-button"
    @click="emit('click')"
    :aria-label="t('player.controls.backward10')"
    :data-tooltip="t('player.controls.backward10') + ' (j)'"
    v-html="backward10Icon"
  />
</template>

<script setup lang="ts">
import { backward10Icon } from '../../assets/icons'
import { useVideoI18n } from '../../i18n'

const emit = defineEmits<{
  click: []
}>()

const { t } = useVideoI18n()
</script>

<style scoped>
/* Styles are in main.scss */
</style>
